// eslint-disable-next-line import/no-extraneous-dependencies

import cn from 'classnames';
import he from 'he';
import { forwardRef } from 'react';
// eslint-disable-next-line import/order
import ProgressBar from '@ramonak/react-progress-bar';

import { useRunRecognizeVideoMutation } from '@shared/api';
import type { Locale } from '@shared/libs';
import { unbounded, Button, ButtonColor, ButtonSize } from '@shared/ui';

import styles from '../ai-player.module.css';

type TProps = {
  locale: Locale;
  id: string;
  recognize?: boolean;
  waiting?: boolean;
  error?: boolean;
  completed?: number;
};

// eslint-disable-next-line react/display-name
export const Empty = forwardRef<HTMLDivElement, TProps>(
  ({ locale, id, recognize, waiting, error, completed }, ref) => {
    const mutation = useRunRecognizeVideoMutation();

    return (
      <div ref={ref}>
        <p className={styles.emptyText}>{locale.AI_PLAYER_EMPTY}</p>
        <div className={styles.emptyWrap}>
          <div className={styles.emptyCard}>
            {recognize && (
              <>
                <p className={cn(styles.emptyCardTitle, unbounded.className)}>
                  {locale.AI_PLAYER_RECOGNIZE_TITLE}
                </p>
                <p className={styles.emptyCardText}>{locale.AI_PLAYER_RECOGNIZE_TEXT}</p>
                {completed && (
                  <ProgressBar
                    key={id}
                    completed={completed}
                    bgColor="#b386fd"
                    height="24px"
                    // labelAlignment="outside"
                  />
                )}
              </>
            )}
            {error && (
              // eslint-disable-next-line react/jsx-no-useless-fragment
              <>
                <p
                  className={cn(styles.emptyCardTitle, unbounded.className)}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: he.decode(
                      locale.AI_PLAYER_RECOGNIZE_ERROR || 'AI_PLAYER_RECOGNIZE_ERROR',
                    ),
                  }}
                />
              </>
            )}
            {waiting && (
              <>
                <p className={cn(styles.emptyCardTitle, unbounded.className)}>
                  {locale.AI_PLAYER_WAITING_TITLE}
                </p>
                <p className={styles.emptyCardText}>{locale.AI_PLAYER_WAITING_TEXT}</p>
              </>
            )}

            {!recognize && !waiting && !error && (
              <>
                <p className={cn(styles.emptyCardTitle, unbounded.className)}>
                  {locale.AI_PLAYER_EMPTY_TITLE}
                </p>
                <Button
                  color={ButtonColor.PURPLE}
                  size={ButtonSize.L}
                  onClick={() => {
                    mutation.mutate({ id });
                  }}
                >
                  {locale.AI_PLAYER_EMPTY_BTN}
                </Button>
                <p className={styles.emptyCardText}>{locale.AI_PLAYER_EMPTY_TEXT}</p>
              </>
            )}
          </div>
          <div className={styles.emptyCardBg} />
        </div>
      </div>
    );
  },
);
